import type { ProductVariant } from "@workspace/crystallize/generated/discovery/";
import { Badge } from "@workspace/ui/components/badge";
import { FormattedPrice } from "@workspace/ui/components/formatted-price";
import { format } from "date-fns";
import { nb } from "date-fns/locale";
import CrystallizeResponsiveImage from "./crystallize-responsive-image";

interface ProductCardProps {
	name: string;
	defaultVariant: ProductVariant;
	availableFrom?: string;
	index?: number;
	sizes?: string;
}

export default function ProductCard({
	name,
	availableFrom,
	defaultVariant,
	index,
	sizes,
}: ProductCardProps) {
	const formattedDate = availableFrom
		? format(new Date(availableFrom), "d. MMMM", { locale: nb })
		: null;

	return (
		<>
			<div className="h-64 w-full flex-none overflow-hidden md:h-80">
				{Array.isArray(defaultVariant.images) &&
					defaultVariant.images.length > 0 &&
					defaultVariant.images[0] ? (
					<CrystallizeResponsiveImage
						image={defaultVariant.images[0]}
						alt={name}
						className="h-full w-full object-cover"
						fetchPriority={index !== undefined && index < 2 ? "high" : "low"}
						sizes={sizes}
					/>
				) : (
					<div className="flex h-full w-full items-center justify-center bg-gray-100 text-gray-400" />
				)}
			</div>
			<div className="flex grow flex-col gap-1 p-4">
				<h3 className="grow font-medium text-lg text-primary">{name}</h3>
				{formattedDate && (
					<p className="text-gray-500 text-sm">
						Tilgjengelig fra {formattedDate}
					</p>
				)}
				<div className="flex items-center gap-2">
					{defaultVariant.defaultPrice != null &&
						defaultVariant.defaultPriceForEveryone != null &&
						defaultVariant.defaultPrice !== defaultVariant.defaultPriceForEveryone && (
							<>
								<FormattedPrice
									price={defaultVariant.defaultPrice}
									variant="discount"
									className="text-muted-foreground text-lg"
								/>
								<Badge variant="destructive" className="text-xs">
									-{Math.round((1 - defaultVariant.defaultPriceForEveryone / defaultVariant.defaultPrice) * 100)}%
								</Badge>
							</>
						)}
					<FormattedPrice
						price={defaultVariant.defaultPriceForEveryone ?? defaultVariant.defaultPrice ?? 0}
						className="font-light text-2xl text-primary"
					/>
				</div>
			</div>
		</>
	);
}
